import React, {useMemo} from 'react'
import Tooltip from '../../core/tooltip'
import {NewInfoIcon} from '../../../icons'
import {colors} from '../../../utils/colors'
import './index.scss'
import classNames from 'classnames'
import {useSelector} from 'react-redux'

const percentages = {
    FULL_PERCENT: 80,
    HALF_PERCENT: 50
}
const INFO_SIZE = 20

const PieProgressChart = ({value, max, config = {}}) => {
    const percentage = useMemo(() => (value / max) * 100, [value, max]) || 0
    const isDarkMode = useSelector(state => state.sidebar.isDarkMode)

    const computedColors = useMemo(() => {
        const {filled, all, textColor, iconColor} = config?.defaultColors || {}

        return percentage >= percentages.FULL_PERCENT
            ? {
                filled: filled || colors.colorRed,
                all: all || colors.colorMediumRed,
                text_color: textColor || colors.colorRed,
                icon_color: iconColor || colors.colorRed
            }
            : percentage >= percentages.HALF_PERCENT
                ? {
                    filled: filled || colors.colorOrange,
                    all: all || colors.colorMutedOrange,
                    text_color: textColor || colors.colorOrange,
                    icon_color: iconColor || colors.colorOrange
                }
                : {
                    filled: filled || colors.colorVividBlue,
                    all: all || colors.colorMutedBlue,
                    text_color: textColor || (isDarkMode ? colors.colorFrostyAzure : colors.colorGray),
                    icon_color: iconColor || colors.colorFilterTitle
                }
    }, [percentage, config?.defaultColors, isDarkMode])

    return (
        <div className={classNames('usage-limit-chart', {
            dark: isDarkMode
        })}>
            <span
                className="circle"
                style={{
                    '--filled-color': computedColors.filled,
                    '--text-color': computedColors.text_color,
                    '--all-color': computedColors.all,
                    '--percentage': `${percentage}%`
                }}
            >
                <span className="circle-content">
                    <span className="circle-label">{`${value}/`}</span>
                    {max}
                </span>
            </span>
            {config?.tooltip_text && (
                <span
                    className="chart-label"
                    style={{
                        '--filled-color': computedColors.filled,
                        '--text-color': computedColors.text_color
                    }}
                >
                    <Tooltip trigger="mouseenter" content={config.tooltip_text} placement="top">
                        {config?.label_text && <span className="label-text">{config.label_text}</span>}
                        <NewInfoIcon
                            fillColor={computedColors.icon_color}
                            width={INFO_SIZE}
                            height={INFO_SIZE}
                        />
                    </Tooltip>
                </span>
            )}
        </div>
    )
}

export default PieProgressChart
